import { connect } from 'react-redux';

import { CONDITION_OPTIONS } from 'legacy/utils/property-details';

import { valueReportAdjustSubjectCondition } from 'actions/edit-report';

import { getIsHandheld } from 'selectors/match-media';
import { getIsReportEditable } from 'selectors/report-permissions';
import { getReportStatusInitialLoadComplete } from 'selectors/report-status';
import {
  getSubjectDefault,
  getSubjectAdjusted,
  getSubjectFormValuesChanged
} from 'selectors/subject';

import ConditionSelector from 'legacy/components/ConditionSelector';

const mapStateToProps = (state) => {
  const subject = getSubjectAdjusted(state);
  const subjectOriginal = getSubjectDefault(state);
  const changedFormValues = getSubjectFormValuesChanged(state);
  const condition = changedFormValues.hasOwnProperty('quality')
    ? changedFormValues.quality
    : subject.quality;
  return {
    isLargeEnoughScreen: !getIsHandheld(state),
    isOriginalValue: condition === subjectOriginal.quality,
    disabled:
      !getReportStatusInitialLoadComplete(state) || !getIsReportEditable(state),
    options: CONDITION_OPTIONS,
    condition
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onChange: (condition) =>
      dispatch(
        valueReportAdjustSubjectCondition({
          quality: condition
        })
      )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConditionSelector);
